import { Card, Layout } from '@/components';
import type { FC, PropsWithChildren, ReactNode } from 'react';

type Props = {
  cardTitle?: ReactNode;
};

export const AuthenticationPagesLayout: FC<PropsWithChildren<Props>> = ({
  cardTitle,
  children,
}) => {
  return (
    <Layout
      style={{
        height: '100vh',
        display: 'flex',
      }}
    >
      <Layout.Content
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Card style={{ width: '50%' }} title={cardTitle}>
          {children}
        </Card>
      </Layout.Content>
    </Layout>
  );
};
